import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';
import { customersReceived } from './customer-actions';

export interface CustomerState {
    customers: PaginatedResponse<AccountListItemDto>;
}

const initialState: CustomerState = {
    customers: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
};

export const customerReducer = createReducer(initialState, builder => {
    builder.addCase(customersReceived, (state, action) => {
        return {
            ...state,
            customers: action.payload,
        };
    });
});
